import { BCMSAsset } from "@bcm-dev/bcms-vite";

// SVG Imports
import ArrowDownloadIcon from "res/img/ArrowDownloadIcon.svg?react";
import ArrowSquareIcon from "res/img/ArrowSquareIcon.svg?react";
import CameraIcon from "res/img/CameraIcon.svg?react";
import CardIcon from "res/img/CardIcon.svg?react";
import CircleProfileIcon from "res/img/CircleProfileIcon.svg?react";
import DollarSignIcon from "res/img/DollarSignIcon.svg?react";
import DollarSignOutlineIcon from "res/img/DollarSignOutlineIcon.svg?react";
import EqualHousingLenderIcon from "res/img/EqualHousingLenderIcon.svg?react";
import EyeIcon from "res/img/EyeIcon.svg?react";
import FaceIDIcon from "res/img/FaceIDIcon.svg?react";
import FDICIcon from "res/img/FDICIcon.svg?react";
import HideEyeIcon from "res/img/HideEyeIcon.svg?react";
import LeftChevronIcon from "res/img/LeftChevronIcon.svg?react";
import LocationPinIcon from "res/img/LocationPinIcon.svg?react";
import NCUAIcon from "res/img/NCUAIcon.svg?react";
import OppositeArrowsIcon from "res/img/OppositeArrowsIcon.svg?react";
import PhoneIcon from "res/img/PhoneIcon.svg?react";
import PlusPersonIcon from "res/img/PlusPersonIcon.svg?react";
import RightChevronIcon from "res/img/RightChevronIcon.svg?react";
import WalletIcon from "res/img/WalletIcon.svg?react";
import XIcon from "res/img/XIcon.svg?react";
import ZelleLogoIcon from "res/img/ZelleLogoIcon.svg?react";

import FDICDigitalSignWhite from "res/img/fdic-digital-sign-white.png";
import FDICDigitalSign from "res/img/fdic-digital-sign.png";
import MyFinancialLogo from "res/img/myFinancialLogo740x200.png";

// IMG ImportsDollarSignOutlineIcon
const assets = {
	// SVG Exports
	"ArrowDownloadIcon" : ArrowDownloadIcon,
	"ArrowSquareIcon" : ArrowSquareIcon,
	"CameraIcon" : CameraIcon,
	"CircleProfileIcon" : CircleProfileIcon,
	"DollarSignIcon" : DollarSignIcon,
	"EqualHousingLenderIcon" : EqualHousingLenderIcon,
	"EyeIcon" : EyeIcon,
	"FaceIDIcon" : FaceIDIcon,
	"HideEyeIcon" : HideEyeIcon,
	"LeftChevronIcon" : LeftChevronIcon,
	"LocationPinIcon" : LocationPinIcon,
	"NCUAIcon" : NCUAIcon,
	"OppositeArrowsIcon" : OppositeArrowsIcon,
	"PhoneIcon" : PhoneIcon,
	"PlusPersonIcon" : PlusPersonIcon,
	"RightChevronIcon" : RightChevronIcon,
	"XIcon" : XIcon,
	"ZelleLogoIcon" : ZelleLogoIcon,
	"WalletIcon" : WalletIcon,
	"CardIcon" : CardIcon,
	"DollarSignOutlineIcon" : DollarSignOutlineIcon,
	"FDICIcon" : FDICIcon,
	// IMG Exports
	"MyFinancialLogo": MyFinancialLogo,
	"FDICDigitalSignWhite" : FDICDigitalSignWhite,
	"FDICDigitalSign" : FDICDigitalSign
}
const { image, svg } = BCMSAsset.init(assets).loadAsset();

// Export a function for images
export function ImageAsset(props){ 
	return (<> { image(props.id, props) } </>); 
}

// Export a function for svgs
export function SVGAsset(props){ 
	
	if(assets[props.id]){
		return (<> { svg(props.id, { ...props, className: `${ props.className ?? "" } icon` }) } </>); 
	}
	return <span className={(props.className?props.className:"material-symbols-outlined material-icon-outlined md-14") +"  icon"}>{props.id}</span>
	
}